import { FC, useEffect } from 'react';

import { GridColumn, GridLayout, GridRow, useBreakpoint } from '@hh.ru/magritte-ui';

import { useRequestCancel } from 'hooks/common/useRequestCancel';

import { CampaignCreationFloatingButton } from 'components/CampaignsDashboard/components/CampaignCreationFloatingButton/CampaignCreationFloatingButton';
import { fetchFiltersList } from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/fetchFiltersList';
import { CampaignsPagination } from 'components/CampaignsDashboard/components/CampaignsPagination';
import { CampaignsTable } from 'components/CampaignsDashboard/components/CampaignsTable/CampaignsTable';
import { fetchCampaignsDetails } from 'components/CampaignsDashboard/utils/fetchCampaignsDetails';
import { fetchCampaignsStatistics } from 'components/CampaignsDashboard/utils/fetchCampaignsStatistics';

import {
    setCampaignsDetails,
    setCampaignsStatistics,
    setIsCampaignsDetailsLoading,
    setIsCampaignsStatisticsLoading,
} from 'store/models/campaignsDashboard';
import { useDispatch, useSelector } from 'store/utils';

export const CampaignsDashboard: FC = () => {
    const isCampaignsLoading = useSelector((state) => state.campaignsDashboard.isCampaignsLoading);
    const isCampaignsStatisticsLoading = useSelector((state) => state.campaignsDashboard.isCampaignsStatisticsLoading);
    const campaigns = useSelector((state) => state.campaignsDashboard.campaigns);

    const dispatch = useDispatch();
    const { isMobile } = useBreakpoint();
    const { abortRequest, abortSignal } = useRequestCancel();
    const { abortRequest: abortRequestFiltersList, abortSignal: abortSignalFiltersList } = useRequestCancel();

    useEffect(() => {
        if (isCampaignsLoading) {
            abortRequest();
        }

        if (isCampaignsStatisticsLoading && !isCampaignsLoading) {
            if (campaigns.size > 0) {
                const campaignIds = [...campaigns.keys()].map(String);
                abortRequest();
                const signal = abortSignal();
                void dispatch(fetchCampaignsDetails({ campaignIds, abortSignal: signal }));
                void dispatch(fetchCampaignsStatistics({ campaignIds, abortSignal: signal }));
            } else {
                dispatch([
                    setIsCampaignsStatisticsLoading(false),
                    setCampaignsStatistics(null),
                    setIsCampaignsDetailsLoading(false),
                    setCampaignsDetails(null),
                ]);
            }
        }

        return () => {
            abortRequest();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCampaignsStatisticsLoading, isCampaignsLoading]);

    useEffect(() => {
        void dispatch(fetchFiltersList({ abortSignal: abortSignalFiltersList() }));

        return () => {
            abortRequestFiltersList();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {isMobile && <CampaignCreationFloatingButton />}
            <GridLayout>
                <GridRow>
                    <GridColumn xs={4} s={8} m={12}>
                        <CampaignsTable />
                        <CampaignsPagination />
                    </GridColumn>
                </GridRow>
            </GridLayout>
        </>
    );
};
